((homepagePublications, $) => {
  'use strict';

  const $dom = {};

  const cacheDom = () => {
    $dom.homepagePublications = $('.home-publications__sliders-container');
  };

  const bindUIActions = () => {

    $dom.homepagePublications.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrow: false,
      dots: true,
      infinite: true,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: "unslick"
        }
      ]
    });
  };

  const init = () => {
    cacheDom();
    bindUIActions();
  };

  homepagePublications.init = init;

})(window.homepagePublications = window.homepagePublications || {}, jQuery);
